var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page"},[_c('h1',[_vm._v("All clients ("+_vm._s(_vm.transitionCount)+") added successfully")]),_c('v-btn',{staticStyle:{"width":"64px","margin-top":"20px","align-self":"center"},on:{"click":_vm.goToDashboard}},[_vm._v("Done")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }